import { useState, useEffect } from 'react';
import axios from 'axios';
import { getHeaders } from '../utility/getHeader';

/**
 * Custom hook to get the close date from the backend API
 * Calls the /last-close-date endpoint to fetch the most recent close date
 * @param {boolean} autoFetch - Whether to automatically fetch on mount
 * @returns {Object} { nextCloseDate, loading, error, refetch }
 */
export const useNextCloseDate = (autoFetch = true) => {
  const [nextCloseDate, setNextCloseDate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNextCloseDate = async () => {
    try {
      setLoading(true);
      setError(null);

      console.log('Fetching last close date from API...');

      // Use the API route to get the last close date
      const response = await axios.get('/last-close-date', getHeaders());

      console.log('API response:', response.data);

      if (response.data && response.data.success && response.data.close_date) {
        const closeDate = response.data.close_date;
        
        console.log('Last close date found:', closeDate);
        
        // Use the close date directly from API
        const formattedDate = new Date(closeDate).toISOString().split('T')[0];
        console.log('Close date set to:', formattedDate);
        
        setNextCloseDate(formattedDate);
      } else {
        console.log('No close date found from API, using today');
        // If no date found, use today's date
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        setNextCloseDate(formattedDate);
      }
    } catch (err) {
      console.error('Error fetching close date from API:', err);
      setError(err.message || 'Failed to fetch close date');
      
      // Fallback to today's date on error
      const today = new Date();
      const formattedDate = today.toISOString().split('T')[0];
      setNextCloseDate(formattedDate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (autoFetch) {
      fetchNextCloseDate();
    }
  }, [autoFetch]);

  return {
    nextCloseDate,
    loading,
    error,
    refetch: fetchNextCloseDate
  };
};

export default useNextCloseDate;